import { Icon } from '../ui/index.js';
import { useOnline } from '../lib/useOnline.js';

/** A calm strip shown when the device loses its connection. */
export function OfflineBanner() {
  const online = useOnline();
  if (online) return null;
  return (
    <div className="pt-offline-banner" role="status">
      <Icon name="alert" size={16} />
      You are offline right now. We will pick up where you left off when you are back.
    </div>
  );
}
